import type { MoneyAmount } from 'types'
import { getMinifiedLocaleCurrencyStringFromMoneyAmount } from 'utils'
import type { MarketplacePurchase } from 'utils/web_api.schemas'

import { OrderProductCard } from '../shared/OrderProductCard'

type OrderDetailsProps = {
  balance: MoneyAmount | null;
  purchase: MarketplacePurchase;
  isMobileView?: boolean;
}

export const OrderDetails = ({
  balance,
  purchase,
  isMobileView = false,
}: OrderDetailsProps) => {
  const variant = purchase.variant
  const product = purchase.product

  const productPrice = variant.discounted_price ?? variant.base_price

  return (
    <div className={isMobileView ? 'flex flex-col' : 'flex flex-col h-full'}>
      <div className={isMobileView ? 'flex flex-col gap-6' : 'flex flex-col mt-24 gap-6 px-6'}>
        {balance && (
          <div>
            <p className='text-sm text-gray-500'>Thatch balance</p>
            <p className={`${isMobileView ? 'heading-sm' : 'heading-xl'} font-normal text-green-400`}>
              {getMinifiedLocaleCurrencyStringFromMoneyAmount(balance)}
            </p>
          </div>
        )}

        <OrderProductCard
          isMobileView={isMobileView}
          productBrand={product.product_brand}
          productSlug={product.slug}
          variantName={variant.name}
          variantBasePrice={variant.base_price}
          variantDiscountedPrice={variant.discounted_price ?? null}
          variantThumbnailImageUrl={variant.thumbnail_image_urls[0]}
        />

        <div className='flex flex-col gap-2 mt-8 self-stretch'>
          <div className='flex justify-between items-center self-stretch'>
            <span className='heading-sm'>Total</span>
            <span className='heading-sm'>
              {productPrice.formatted_amount}
            </span>
          </div>

          {balance && (
            <div className='flex justify-between items-center self-stretch'>
              <span className='heading-sm'>Current balance</span>
              <span className='heading-sm text-green-400'>
                {getMinifiedLocaleCurrencyStringFromMoneyAmount(balance)}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
